import '../../assets/scss/Compliance.scss'

const report = () => {
    return(
        <>
        <section className="m-wrap about-ovpr irb-ibc">
          <div className='container'>
            <h2 className="text-hbku-primary p-b-3">Research Misconduct Overview</h2>
           <p>Hamad Bin Khalifa University (HBKU) is dedicated to upholding the highest standards of research integrity and ethical conduct. Research misconduct not only violates these principles but also erodes trust, wastes university resources, and stalls the advancement of knowledge. The university's research misconduct policy and guidelines provide a clear framework for reporting and addressing allegations in a fair and transparent manner.</p>
            <h2 className="text-hbku-primary mt-3 mt-lg-5 pt-0 pt-lg-4 p-b-3">Defining Research Misconduct</h2>
            <p>Research misconduct includes fabrication, falsification, plagiarism, or other practices that seriously deviate from accepted norms within the research community. Honest errors or differences of opinion are not considered misconduct.</p>
             <h2 className="text-hbku-primary mt-3 mt-lg-5 pt-0 pt-lg-4  p-b-3">Applicability</h2>
             <p>This applies to all members of the HBKU community involved in research and scholarly activities, including faculty, researchers, students, staff, collaborators, and affiliates, regardless of funding source or affiliation.</p>

            <h2 className="text-hbku-primary mt-3 mt-lg-5 pt-0 pt-lg-4  p-b-3">Reporting and Investigation</h2>
            <div class="l-article">
                <ul class="mb-5">
                    <li>All HBKU community members are required to promptly report observed or suspected research misconduct.</li>
                    <li>Allegations can be made verbally, in writing, or anonymously to the Research Integrity Officer (RIO) or via the Vice President for Research (VPR) web portal.</li>
                    <li>The policy ensures a fair, thorough, and confidential process for assessing allegations, including preliminary assessment, investigation, decision, and appeal.</li>
<li>Findings of misconduct require proof of significant departure from accepted practices, intentional or reckless behaviour, and must be supported by a preponderance of the evidence.</li>
                </ul>
            </div>

                  <div className="l-article l-accordion l-accordion4 p-b-3">
                <div className="mez slider">
                    <h3 className="l-accordion__title">
                        <span>References</span>
                    </h3>
                    <div className="l-accordion__content">
                    <ul className="mb-5">
                        <li><a href='https://www.hbku.edu.qa/sites/default/files/250828_Final_President%20Approved_Research_Misconduct_Policy.pdf' target='_blank'>HBKU Misconduct Policy</a> </li>
                        {/* <li><a href='#'>Misconduct Procedure (to Follow)</a></li> */}
                    </ul>
                    </div>
                </div>
            </div>

             <h2 className="text-hbku-primary mt-3 mt-lg-5 pt-0 pt-lg-4  p-b-3">Reporting Misconduct Allegation</h2>
             <p>To report research misconduct, please email <a class="text-blue" href='mailto:research.compliance@hbku.edu.qa'> research.compliance@hbku.edu.qa</a>  and attach supporting documents</p>


            
          </div>
        </section>
        </>
    )
}

export default report;


